console.log('🚨 MAIN.JSX LOADED - TIMESTAMP:', Date.now());

// frontend/src/main.jsx
// ✅ STEP 1: Unregister Service Worker and Clear Caches FIRST
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    for(let registration of registrations) {
      console.log('🗑️ Unregistering service worker:', registration.scope);
      registration.unregister();
    }
  });
  
  // Clear all caches
  if ('caches' in window) {
    caches.keys().then(function(cacheNames) {
      return Promise.all(
        cacheNames.map(function(cacheName) {
          console.log('🗑️ Deleting cache:', cacheName);
          return caches.delete(cacheName);
        })
      );
    }).then(() => {
      console.log('✅ All caches cleared');
    });
  }
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router.jsx';

console.log('🚨 ROUTER IMPORTED:', router);

// --- Global Context Providers ---
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { SocketProvider } from './contexts/SocketContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ModalProvider } from './contexts/ModalContext';
import './app/globals.css';  // ← ADD THIS LINE (for landing page)

// --- Global Styles ---
import './index.scss';

const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error("Fatal Error: Root element with ID 'root' not found in index.html. React application cannot mount.");
  document.body.innerHTML = '<div style="text-align: center; padding-top: 50px;"><h1>Application Error</h1><p>Could not initialize the application. Root DOM element missing.</p></div>';
} else {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ThemeProvider>
        <AuthProvider>
          <SocketProvider>
            <NotificationProvider>
              <ModalProvider>
                <RouterProvider router={router} />
              </ModalProvider>
            </NotificationProvider>
          </SocketProvider>
        </AuthProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
}

console.log('✅ App initialized successfully');
